import { useState } from 'react';

import { exportCsv } from '../../../../helpers/csv/csvHelper';

import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, FormGroup, FormControlLabel, Checkbox, Box
} from '@mui/material';

import { INCOMPLETE_ORDER_EXPORT_COLUMNS } from '../../../../constants/admin/order_constants';

const PedidosExportacion = ({ open, setOpen, data }) => {
    // columnas seleccionadas
    const [selectedColumns, setSelectedColumns] = useState(
        INCOMPLETE_ORDER_EXPORT_COLUMNS.map(({ title, field }) => ({ title, field, checked: true }))
    );

    // valores para checkbox padre
    const total = selectedColumns.length;
    const checkedCount = selectedColumns.filter(c => c.checked).length;

    // ¿todas seleccionadas?
    const allChecked = checkedCount === total;
    const isIndeterminate = checkedCount > 0 && checkedCount < total;

    const handleClose = () => setOpen(false);

    // seleccionar todas o ninguna columna
    const mainHandleChange = ({ target: { checked } }) => {
        setSelectedColumns(e =>
            e.map(column => ({
                ...column, checked
            }))
        );
    };

    // seleccionar columnas
    const handleChange = columnName => ({ target: { checked } }) => {
        setSelectedColumns(
            e => e.map(
                (column) => column.field === columnName
                ? { ...column, checked }
                : column
            )
        )
    };

    // generar archivo .csv
    const exportFile = () => {
        exportCsv('pedidos_incompletos.csv')(selectedColumns.filter(({ checked }) => checked), data);
        handleClose();
    };

    return (
        <Dialog open={open} onClose={ handleClose }>
            <DialogTitle>Campos a incluir en archivo</DialogTitle>
            <DialogContent>
                <FormGroup>
                    <FormControlLabel
                        label="Todos"
                        control={
                            <Checkbox
                                size="small"
                                checked={allChecked}
                                indeterminate={isIndeterminate}
                                onChange={mainHandleChange}
                            />
                        }
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
                        {
                            selectedColumns.map(({ title, field, checked }, i) =>
                                <FormControlLabel key={i}
                                    control={
                                        <Checkbox
                                            size="small"
                                            name={field}
                                            checked={checked}
                                            onChange={handleChange(field)}
                                        />
                                    } label={title}
                                />
                            )
                        }
                    </Box>
                </FormGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={exportFile}>
                    Exportar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PedidosExportacion;
